module.exports = __webpack_public_path__ + "static/media/_greece.b54e0c7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_greece.svg
// module id = 2325
// module chunks = 7